
























































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as temp from "../../_store/temp.module";
import { InstituteInfo } from "../../_models/instituteInfo";
import { bus } from "../../main";

@Component
export default class GiorniDialog extends Vue {
  @Prop() listaTurni!: any;
  private dialog: boolean;
  private search: string;
  private loadingData: boolean;

  private addOraTurno: string;
  private editOraTurno: string;
  private add: boolean;
  private edit: boolean;
  private editTurnoMenu: boolean;
  private addTurnoMenu: boolean;

  private idTurnoEdit: number;

  constructor() {
    super();
    this.dialog = false;
    this.search = "";
    this.loadingData = true;

    this.editOraTurno = ""
    this.addOraTurno = ""
    this.add = false;
    this.edit = false;
    this.addTurnoMenu = false;
    this.editTurnoMenu = false;

    this.idTurnoEdit = 0;
  }

  showAdd() {
    this.add = true;
  }

  closeAdd() {
    this.add = false;
    this.addOraTurno = "";
  }

  addTurno() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico,
      turno: this.addOraTurno
    };
    user
      .dispatchAddTurnoWorkshop(this["$store"], payload)
      .then(() => {
        this.add = false;
        bus.$emit("successfullOperation", "Turno aggiunto con successo");
        bus.$emit("loadTurni");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  showEdit(idTurno: number, turno: string) {
    this.edit = true;
    this.editOraTurno = turno;
    this.idTurnoEdit = idTurno;
  }

  closeEdit() {
    this.edit = false;
    this.editOraTurno = "";
  }

  editTurno() {
    var payload = {
      idTurno: this.idTurnoEdit,
      turno: this.editOraTurno
    };
    user
      .dispatchEditTurnoWorkshop(this["$store"], payload)
      .then(() => {
        this.edit = false;
        bus.$emit("successfullOperation", "Turno modificato con successo");
        bus.$emit("loadTurni");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  deleteTurno(idTurno: number) {
    var payload = {
      idTurno: idTurno
    };
    user
      .dispatchDeleteTurnoWorkshop(this["$store"], payload)
      .then(() => {
        bus.$emit("successfullOperation", "Turno eliminato con successo");
        bus.$emit("loadTurni");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  close() {
    this.dialog = false;
    bus.$emit("loadSchedulazioneWorkshop");
  }
}
